// extracted by mini-css-extract-plugin
module.exports = {"BindingContract_body":"BindingContract_BindingContract_body__2g4dL","ant-upload":"BindingContract_ant-upload__2dcCg"};